import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import { isAfter, eachDayOfInterval, subDays, format } from "date-fns";
import FormGroup from "@material-ui/core/FormGroup";
import TableContainer from "@material-ui/core/TableContainer";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import {
    MuiPickersUtilsProvider,
    TimePicker,
    DatePicker
} from "material-ui-pickers";
import qs from "qs";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { CSVLink } from "react-csv";

const GARMIN_EXPORT_RESOURCES = [
  { key: "steps", label: "步數" },
  { key: "floorsclimbed", label: "爬梯數" },
  { key: "distanceinmeters", label: "距離" },
  { key: "averageheartrateinbeatsperminute", label: "平均心率" },
  { key: "averagestresslevel", label: "壓力" }
];

const styles = theme => ({
    container: {
        marginTop: 0
    },
    root: {
        width: "100%",
        marginTop: theme.spacing.unit * 3,
        overflowX: "auto"
    },
    table: {
        minWidth: 700
    },
    grid: {
        width: "100%",
        alignItems: "center",
        justifyContent: "flex-start",
        marginTop: 50
    },
    button: {
        height: 40,
        margin: theme.spacing.unit
    },
    datePicker: {
        margin: theme.spacing.unit * 2
    },
    formControl: {
        margin: 16,
        minWidth: 178
    },
    textField: {
        margin: 16,
        minWidth: 178
    },
    container: {
        maxHeight: 1000
    }
});
const tableheadstyle = {
    position: "sticky"
};
const generateTableHead = ({ start, end }) => {
    const ret = eachDayOfInterval({
        start: new Date(start),
        end: new Date(end)
    }).map(d => (
        <TableCell align="right" key={d}>
            {format(new Date(d), "MMM, dd")}
        </TableCell>
    ));
    return ret;
};

class GarminResource extends Component {
    state = {
        data: [],
        selectedStartDate: subDays(new Date().setHours(0, 0, 0, 0), 6),
        selectedEndDate: new Date(),
        start: subDays(new Date().setHours(0, 0, 0, 0), 6),
        end: new Date(),
        csvData: [],
        downloading: false,
        frequency: "1d",
        csvDataByReceiveDate: [],
        receivedatestart: 3,
        receivedateend: 3
    };

    handleStartDateChange = date => {
        this.setState({ selectedStartDate: format(date, "yyyy-MM-dd") });
      };
    
      handleEndDateChange = date => {
        this.setState({ selectedEndDate: format(date, "yyyy-MM-dd") });
      };

      handlePickerOnClick = () => {
        let start = this.state.selectedStartDate;
        let end = this.state.selectedEndDate;
    
        if (isAfter(new Date(start), new Date(end))) {
          let tmp = start;
          start = end;
          end = tmp;
        }
    
        window.location = `?start=${start}&end=${end}`;
      };

    async getGarminResourceByRange({ start, end }) {
        const uniqid = this.props.uniqid;
        const resource = this.props.resource;
        try {
            const result = await fetch(
                `/api/getGarminResourceByRange?resource=${resource}&uniqid=${uniqid}&start=${start}&end=${end}`,
                {
                    mode: "cors",
                    method: "GET"
                }
            );

            const data = await result.json();

            this.setState({ data: data });
        } catch (err) {
            console.log(err);
        }
    }

    fetchGarminResource = async (resource, start, end) => {
        const uniqid = this.props.uniqid;
        const result = await fetch(
            `/api/getGarminResourceByRange?resource=${resource}&uniqid=${uniqid}&start=${start}&end=${end}`,
            {
                mode: "cors",
                method: "GET"
            }
        );
        return result.json();
    };

    downloadAllGarminData = async () => {
        const { start, end } = this.state;
        this.setState({ downloading: true });
        try {
            const results = await Promise.all(
                GARMIN_EXPORT_RESOURCES.map(async item => {
                    const data = await this.fetchGarminResource(item.key, start, end);
                    return { key: item.key, label: item.label, data: Array.isArray(data) ? data : [] };
                })
            );

            const dates = eachDayOfInterval({
                start: new Date(start),
                end: new Date(end)
            }).map(d => format(new Date(d), "yyyy/MM/dd"));

            const byUser = {};
            results.forEach(({ label, data }) => {
                data.forEach(u => {
                    if (!byUser[u.user_id]) {
                        byUser[u.user_id] = {
                            serial_number: u.serial_number,
                            name: u.name,
                            metrics: {}
                        };
                    }
                    byUser[u.user_id].metrics[label] = u.value || [];
                });
            });

            const csvData = [];
            Object.values(byUser).forEach(u => {
                dates.forEach((date, i) => {
                    const row = {
                        個案編號: u.serial_number,
                        姓名: u.name,
                        日期: date
                    };
                    GARMIN_EXPORT_RESOURCES.forEach(item => {
                        const values = u.metrics[item.label] || [];
                        row[item.label] = values[i] != null ? values[i] : "";
                    });
                    csvData.push(row);
                });
            });

            this.setState({ csvData, downloading: false }, () => {
                if (this.csvLink && this.csvLink.link) {
                    this.csvLink.link.click();
                }
            });
        } catch (err) {
            console.log(err);
            this.setState({ downloading: false });
        }
    };

    componentDidMount() {
        const start =
            qs.parse(this.props.search, { ignoreQueryPrefix: true }).start ||
            format(subDays(new Date().setHours(0, 0, 0, 0), 6), "yyyy-MM-dd");
        const end =
            qs.parse(this.props.search, { ignoreQueryPrefix: true }).end ||
            format(new Date(), "yyyy-MM-dd");
        this.setState({
            start,
            end,
            selectedStartDate: start,
            selectedEndDate: end
        });
        this.getGarminResourceByRange({ start, end });
    }

    handleChange = name => event => {
        this.setState({
          [name]: event.target.value
        });
      };

    render() {
        const { resource, classes } = this.props;
        const { selectedStartDate, selectedEndDate, start, end, downloading } = this.state;
        let { group_name } = this.props;
        if (typeof this.props.group_name === "string") {
            group_name = group_name.trim();
        }

        return (
            <div className={classes.container}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Paper>
                  <Grid container className={classes.grid} justify="space-around">
                    <DatePicker
                      margin="normal"
                      label="開始日期"
                      value={selectedStartDate}
                      onChange={this.handleStartDateChange}
                      className={classes.datePicker}
                    />
                    <DatePicker
                      margin="normal"
                      label="結束日期"
                      value={selectedEndDate}
                      onChange={this.handleEndDateChange}
                      className={classes.datePicker}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      onClick={this.handlePickerOnClick}
                    >
                      搜尋
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      onClick={this.downloadAllGarminData}
                      disabled={downloading}
                    >
                      {downloading ? "下載中..." : "下載資料"}
                    </Button>
                    <CSVLink
                      filename={`${group_name || "Garmin"}_garmin資料_${start}_${end}.csv`}
                      data={this.state.csvData}
                      ref={ref => {
                        this.csvLink = ref;
                      }}
                      style={{ display: "none" }}
                    />
                  </Grid>
                </Paper>
              </MuiPickersUtilsProvider>
      
              <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                <Table stickyHeader className={classes.table}>
                  <TableHead>
                    <TableRow style={{ whiteSpace: "nowrap" }}>
                      <TableCell style={tableheadstyle}>個案姓名</TableCell>
                      {generateTableHead({ start, end })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.data.map(row => (
                      <TableRow key={row.user_id}>
                        <TableCell component="th" scope="row">
                          {row.name}
                        </TableCell>
                        {row.value.map((s, i) => {
                          let d;
                            d = s;      
                          return (
                            <TableCell key={`${d}${i}`} align="right">
                              {d}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
               </TableContainer>
              </Paper>
            </div>
          );
    }
}

GarminResource.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(GarminResource);
